import { createColumnHelper } from '@tanstack/react-table';
import cn from 'classnames';
import { CopyButton } from '#components/atoms/buttons/copy-button/CopyButton.tsx';
import { Table } from '#components/patterns/table/Table.tsx';
import type { Domain } from '#dn-types/domain.ts';
import styles from './DomainDetailsTable.module.css';

type Props = {
  domain: Domain;
  className?: string;
};

type TableData = {
  name: string;
  value: string;
  isCopyable: boolean;
};

const columnHelper = createColumnHelper<TableData>();

const columns = [
  columnHelper.accessor('name', {
    size: 50,
    minSize: 60,
    meta: { className: styles.DomainDetailsTable_label },
  }),
  columnHelper.accessor('value', {
    size: 350,
    cell(info) {
      const value = info.getValue();
      const { isCopyable, name } = info.row.original;
      return (
        <div className="flex align-center">
          {value}
          {isCopyable ?
            <CopyButton
              className="ml-4"
              value={value}
              initialTooltip={`Copy ${name.toLowerCase()}`}
              successTooltip={`Copied ${value}!`}
            />
          : null}
        </div>
      );
    },
  }),
];

export function DomainDetailsTable({ domain, className }: Props) {
  const domainRows = [
    { name: 'Domain', value: domain.domainName, isCopyable: false },
    { name: 'Type', value: 'TXT', isCopyable: false },
    { name: 'Name', value: domain.zone, isCopyable: true },
    { name: 'Value', value: domain.value, isCopyable: true },
  ] satisfies TableData[];
  return <Table className={cn(className, styles.DomainDetailsTable)} data={domainRows} columns={columns} />;
}
